import React from 'react';
import Button from "../../../../UI/Button";

const ModalBodyDeleteDetails = (props) => {
  const {type, id, floatingAccountCode, title,} = props.modalData
  return (
    <div>
      <h6 className={"alert alert-danger"}>
          شما در حال حذف شناوری {title} هستید.
      </h6>
      <div className={"mt-5 text-center"}>
        <Button color={'pBtn'} onClick={() => props.deleteHandler(id, floatingAccountCode)}> حذف شناوری </Button>
        <Button color={'redBtn'} onClick={props.closeModal}> لغو </Button>
      </div>
    </div>
  );
};

export default ModalBodyDeleteDetails;
